export const filters = {
	searchPlaceholder: "Rechercher des produits...",
	clearSearch: "Effacer la recherche",
	allProducts: "Tous les produits",
	activeProducts: "Produits actifs",
	inactiveProducts: "Produits inactifs",
	viewByCategory: "Voir par Catégorie",
	viewByMenuCategory: "Voir par Catégorie de Menu",
	clearFilters: "Effacer les filtres",
};
